<template>
<div id="container">
  <div class="locationWrap policy">
    <div>
      <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
      <strong class="inner locTit aniBox type_bot gogo">
        <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>이용약관
      </strong>
    </div>
  </div>
  <div class="contents">
    <div class="inner">
      <div class="subTitWrap aniBox type_left gogo">
        <h2>이용약관</h2>
      </div>

      <div class="terms-box" style="height:auto;border:0">
          <h1>제 1 장 총칙</h1>
          <h2>제1조 (목적)</h2>
          <div class="terms-conditions">
            이 약관은 DAMDA(이하 "담다"라 함)가 제공하는 홈페이지(godamda.kr) 서비스(이하 "서비스"라 함)의 이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.
          </div>
          <h2>제2조 (약관의 효력 및 변경)</h2>
          <div class="terms-conditions">
            ① 이 약관은 담다의 홈페이지 서비스 화면으로 이용 고객에게 그 내용을 공지함으로써 효력이 발생합니다.<br>
            ② 담다는 필요하다고 인정되는 경우에 이 약관을 개정할 수 있으며, 개정된 내용은 제1항과 같은 방법으로 공지한 때로부터 그 효력을 발생합니다.
          </div>
          <h2>제3조 (약관적용 외 준칙)</h2>
          <div class="terms-conditions">
            이 약관에 명시되지 않은 사항이 관계법령에 규정되어 있는 경우에는 그 규정에 따릅니다.
          </div>
          <h2>제4조 (용어의 정의)</h2>
          <div class="terms-conditions">
            ① 이 약관에서 사용하는 용어의 정의는 다음 각 호와 같습니다.<br>
            1. "서비스"라 함은 홈페이지에서 제공하는 제반서비스(정보제공, 부가서비스 등)를 말합니다.<br>
            2. "회원"이라 함은 담다와 서비스 이용계약을 체결하고 회원ID를 부여받은 개인 또는 법인을 말합니다.<br>
            3. "이용계약"이라 함은 서비스 이용을 목적으로 담다와 이용자간에 체결하는 계약을 말합니다.<br>
            4. "회원ID"라 함은 회원의 식별과 회원의 서비스이용을 위하여 회원이 선정하고 담다가 승인하는 문자와 숫자의 조합을 말합니다.<br>
            5. "회원정보"라 함은 회원이 이용계약을 체결할때 담다에 등록하는 회원ID, 이름, 전화번호, 직업 등의 회원에 관한 정보를 말합니다.<br>
            6. "비밀번호"라 함은 회원ID와 일치된 회원임을 확인하고 회원 자신의 비밀을 보호하기 위하여 회원 자신이 설정한 문자와 숫자의 조합을 말합니다.
          </div>

          <h1>제 2 장 이용계약 체결</h1>
          <h2>제5조 (이용계약(회원가입) 체결)</h2>
          <div class="terms-conditions">
            ① 회원에 등록하여 서비스를 이용하고자 하는 자는 담다에서 요청하는 회원에 관한 정보를 본인이 성실하게 작성, 등록함을 원칙으로 합니다.<br>
            ② 회원등록은 이용 희망자가 본 이용약관을 열람한 후 회원 가입신청서 양식에 따라 관련사항을 기재하고 "동의함" 버튼을 누르면 이 약관에 합법적으로 동의하는 것으로 간주합니다.<br>
            ③ 이용자가 모든 사항을 성실히 기재하여 이용 신청을 완료하였을때 담다가 이용 신청에 대해 승낙함으로써 계약이 체결됩니다.
          </div>
          <h2>제6조 (계약 해지)</h2>
          <div class="terms-conditions">
            ① 이용자가 서비스 이용 계약을 해지하고자 하는 때에는 이용자 본인이 사전에 온라인, E-mail, 방문, 전화, 또는 팩스를 통하여 담다에 해지 신청을 해야 합니다.<br>
            ② 회원에게 다음 각 항에 해당하는 사유가 발생하였을 경우 담다는 사전 통보 없이 계약을 해지 할 수 있습니다.<br>
            1. 담다의 명예를 훼손하였을 경우<br>
            2. 서비스 운영을 고의로 방해한 경우<br>
            3. 타인 회원ID 및 비밀번호를 도용한 경우<br>
            4. 가입 신청서를 허위로 작성한 경우<br>
            5. 국익 및 사회 공익을 저해하는 행위를 계획 또는 실행한 경우<br>
            6. 기타 담다가 회원으로서 부적합하다고 판단한 경우
          </div>

          <h1>제 3 장 서비스 이용</h1>
          <h2>제7조 (서비스 제공 및 광고의 게재)</h2>
          <div class="terms-conditions">
            ① 담다는 서비스의 무료 운용과 관련하여 서비스 화면, 홈페이지, 이메일 등에 광고를 게재 할 수 있습니다.<br>
            ② 담다는 필요한 경우에는 서비스의 내용을 추가 또는 변경할 수 있습니다. 이때 담다는 그 내용을 사전에 공지사항으로 공시합니다.
          </div>
          <h2>제8조 (서비스 이용)</h2>
          <div class="terms-conditions">
            ① 서비스 이용은 담다의 업무상 또는 기술상 특별한 지장이 없는한 연중무휴, 1일 24시간 제공을 원칙으로 합니다.<br>
            ② 단, 천재지변, 정부예산의 변경, 타 기관에 의한 사유, 시스템 점검 등 담다가 필요한 경우 또는, 시스템 장애, 서비스 이용의 폭주 등 불가항력으로 인하여 서비스를 중단 할 수 있습니다.<br>
            ③ 담다는 회원이 보다 효과적으로 활용할 수 있도록 서비스 사항에 대한 변동 내용을 공지하여야 합니다.<br>
            ④ 회원은 담다로부터 검색한 자료의 지적재산권에 관한 사항과 데이터베이스 제작자가 요구하는 사항을 준수하여야 합니다.
          </div>
          <h2>제9조 (서비스 제공의 제한 및 중지)</h2>
          <div class="terms-conditions">
            ① 담다는 다음 각 호에 해당하는 경우 서비스 제공의 일부 또는 전부를 제한하거나 중지 할 수 있습니다.<br>
            1. 서비스용 설비의 보수, 정기점검 또는 공사로 인한 부득이한 경우<br>
            2. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우<br>
            3. 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우<br>
            4. 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 경우<br>
            5. 제12조 회원의 의무를 현저히 위반했을 경우<br>
            ② 담다는 제1항의 규정에 의하여 서비스 제공의 일부 또는 전부를 제한하거나 중지 할 때에는 그 사유 및 제한기간 등을 지체없이 공지사항이나 이메일 등을 통하여 회원에게 알립니다.
          </div>

          <h1>제 4 장 권리 및 의무</h1>
          <h2>제10조 (담다의 의무)</h2>
          <div class="terms-conditions">
            ① 담다는 이 약관 및 관계법령에 따라 계속적, 안정적으로 서비스를 제공할 수 있도록 최선의 노력을 다합니다.<br>
            ② 담다는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 적절한 절차를 거쳐 신속히 처리하며, 처리 기간이 지연될 경우 회원에게 지연 사유와 처리일정을 알려드립니다.<br>
            ③ 담다는 회원이 담다의 서비스 제공으로부터 기대되는 이익을 얻지 못하였거나 서비스 자료에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대하여는 책임을 면합니다.
          </div>
          <h2>제11조(회원정보의 보호)</h2>
          <div class="terms-conditions">
            ① 담다는 회원의 정보를 운영하거나 개선하는 목적으로만 사용합니다.<br>
            ② 담다가 취득한 회원정보는 1항에 기재된 목적으로 만 사용하며, 본인의 승낙없이 제3자에게 공개하지 않습니다.<br>
            다만, 물품배달의 목적의 경우 배달에 필요한 정보만 제공하며 그 외의 경우는 제외합니다.<br>
            ③ 담다는 회원정보의 보호에 최선을 다합니다.
          </div>
          <h2>제12조 (회원의 의무)</h2>
          <div class="terms-conditions">
            ① 회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 담다가 통지하는 사항을 준수하여야 하며, 기타 담다의 업무에 방해되는 행위를 하여서는 아니됩니다.<br>
            ② 회원은 서비스를 이용하여 얻은 홈페이지의 정보를 담다의 사전 승낙없이 복사, 복제, 변경, 번역, 출판, 방송, 기타의 방법으로 사용하거나 이를 타인에게 제공 할 수없습니다.<br>
            ③ 회원은 자신의 회원ID와 비밀번호를 유지 관리할 책임이 있으며, 자신의 회원ID와 비밀번호를 사용하여 발생하는 모든 결과에 대해 전적인 책임이 있습니다. 또한 자신의 회원ID와 비밀번호가 자신의 승낙없이 사용되었을 경우 즉시 담다에 신고하여야 합니다.<br>
            ④ 회원은 이용 신청시의 기재내용에 대해 진실하고 정확하며 현재의 사실과 일치하도록 유지하고 갱신하여야 합니다.<br>
            ⑤ 회원은 음란물 게재, 유포 등 사회질서를 해치는 행위, 타인의 명예를 훼손하거나 모욕하는 행위와 타인의 지적재산권 등의 권리를 침해하는 행위를 할 수 없습니다.
          </div>

          <h2>[부 칙]</h2>
          <div class="terms-conditions">
            1. (시행일) 이 약관은 2019년 10월 1일부터 시행합니다.<br>
            2. (경과조치) 이 약관 시행일 전부터 이용자로 등록하여 홈페이지 정보서비스를 이용하고 있는 이용자가 이 약관에 동의하지 않는 경우에는 이용자 등록을 취소하여야 합니다.<br>
            만일, 이 약관 시행일로 부터 3개월 이내에 회원등록을 취소하지 않는 이용자는 이 약관 내용에 동의하는 것으로 간주합니다.
          </div>
        </div>

    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EtcTermsUse.vue